import { ApiService } from '~/shared/api'
import { PageSeo } from '~/models/seo'
import { API_PREFIX } from '~/shared/const/request-services'
import { isNonEmptyArray } from '~/shared/utils/guards'
import { unwrapData } from '~/shared/utils/response'

export class PageSeoService extends ApiService {
  async getByUrl(url: string): Promise<PageSeo> {
    const res = await this.http.request({
      url: `${API_PREFIX}/pages/getbyurl`,
      params: { url },
    })

    const data = unwrapData(res.data)
    if (isNonEmptyArray(data)) {
      return new PageSeo(data[0])
    }

    return new PageSeo()
  }
}
